module.exports = __webpack_public_path__ + "img/userD06.f17e4a9f.jpg";